import * as interactionsAPI from '@debbie/cortex/dist/api/interactions.js';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../utils/errors.js';
import Interaction from '../Interaction/Interaction.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
const PreviewInteraction = (props) => {
    const lang = useSelector((s) => s.lang);
    const [previewInteraction, setPreviewInteraction] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const loadPreview = async () => {
        setLoading(true);
        setPreviewInteraction(null);
        try {
            const _previewInteraction = await interactionsAPI.generate(props.interaction, props.versionId);
            setLoading(false);
            setPreviewInteraction(_previewInteraction);
        }
        catch (error) {
            console.error('Error generating preview interaction:', error);
            errorNotification(lang, error, 'any', lang.errorEntities.preview);
            setLoading(false);
        }
    };
    useEffect(() => {
        loadPreview();
    }, []);
    return (React.createElement(React.Fragment, null,
        loading && React.createElement(PlaceholderLoader, null),
        previewInteraction && (React.createElement(Interaction, { interaction: previewInteraction, alwaysExtended: true }))));
};
export default PreviewInteraction;
//# sourceMappingURL=PreviewInteraction.js.map